import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./app.menu.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * MenuApi class.
 */
export default class MenuApi {
    /**
     * @param {$http} $http - Angular $http service
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.menu;
    }

    /**
     * Get Application menu config
     * @returns {promise}
     */
    getAppMenu() {
        return this.$http.get(this.config.appMenuUrl).then(responseDataExtractor);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/menu/menu.service.js